const TOOL_NAME_PATTERN = /"name"\s*:\s*"([^"]+)"/g;
const SELECT_PREFIX_PATTERN = /^\s*select\s*:\s*/i;

function toNonEmptyString(value: unknown): string | undefined {
  if (typeof value !== 'string') {
    return undefined;
  }

  const trimmed = value.trim();

  return trimmed.length > 0 ? trimmed : undefined;
}

function splitToolNameList(value: string): string[] {
  return value
    .replace(SELECT_PREFIX_PATTERN, '')
    .split(/[\s,]+/)
    .map((name) => name.trim())
    .filter((name) => name.length > 0);
}

export function parseLoadedToolNames(output: string): string[] {
  const schemaSection = output.includes('<functions>')
    ? output.slice(output.indexOf('<functions>'))
    : output;
  const names = [...schemaSection.matchAll(TOOL_NAME_PATTERN)].map(
    (match) => match[1],
  );

  return Array.from(new Set(names));
}

export function extractLoadToolsSummaryLine(
  output: string,
  toolCount: number,
): string {
  const beforeSchemas = output.split('<functions>')[0];
  const trimmed = beforeSchemas?.trim().replace(/\s+/g, ' ');

  if (trimmed) {
    return trimmed;
  }

  return `Loaded ${toolCount} tool${toolCount === 1 ? '' : 's'}`;
}

export function getSelectedToolNamesFromArgs(
  args: Record<string, unknown>,
): string[] {
  const list = args.tools ?? args.names ?? args.select ?? args.toolNames;

  if (Array.isArray(list)) {
    return list.filter(
      (value): value is string =>
        typeof value === 'string' && value.trim().length > 0,
    );
  }

  const query = toNonEmptyString(args.query) ?? toNonEmptyString(list);

  return query ? splitToolNameList(query) : [];
}

export function summarizeSelectedToolNames({
  args,
  formatName = (name: string) => name,
}: {
  args: Record<string, unknown>;
  formatName?: (name: string) => string;
}): string | undefined {
  const names = getSelectedToolNamesFromArgs(args).map(formatName);

  if (names.length === 0) {
    return undefined;
  }

  const head = names.slice(0, 3).join(', ');

  return names.length > 3 ? `${head} +${names.length - 3}` : head;
}
